"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = void 0;
var _mui = require("@ori-ui/mui");
var _renderer = require("@react-pdf/renderer");
/* istanbul ignore file -- not testable */ _renderer.Font.register({
    family: 'OriSans',
    src: 'https://static-dev.oriflame.com/fonts/v2/fonts/sans-regular.ttf'
});
const styles = exports.styles = _renderer.StyleSheet.create({
    body: {
        paddingTop: 50,
        paddingBottom: 50,
        paddingHorizontal: 40,
        fontFamily: 'OriSans',
        backgroundColor: _mui.theme.palette.grey[100],
        lineHeight: 1.5
    },
    collection: {
        flexDirection: 'column',
        marginTop: 20
    },
    questionBlock: {
        padding: 10,
        backgroundColor: _mui.theme.palette.common.white,
        borderRadius: 5,
        marginBottom: 15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    question: {
        color: '#333',
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5
    },
    answer: {
        fontSize: 12,
        fontWeight: 'normal',
        color: _mui.theme.palette.text.secondary
    },
    title: {
        fontSize: 20,
        textAlign: 'center',
        color: _mui.theme.palette.text.primary,
        marginBottom: 20,
        textTransform: 'uppercase',
        letterSpacing: 1
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        fontSize: 10,
        color: 'grey',
        textAlign: 'center'
    }
});
